<template>
  <el-dialog
    class="ts-modal ts-modal--sga no-padding"
    :before-close="closeModal"
    :visible.sync="showModal"
    width="740px"
    title="Role Info"
    id="role-details"
  >
    <div class="ts-modal--sga-header">
      <div class="ts-modal--sga-header_profile">
        <div class="match_percent">
            <el-progress
              type="circle"
              :width="70"
              :stroke-width="4"
              color="#14223C"
              :percentage="Math.round(jobSeekerInfo.matchedPercentage)"
            ></el-progress>
        </div>
        <div style="padding-left:20px;padding-top:15px;">
          <h6 style="word-break: break-word;">{{ jobSeekerInfo.roleTitle }}</h6>
          <span style="word-break: break-word;">{{ jobSeekerInfo.companyName }}</span>
        </div>
      </div>

      <div> 
        <div style="padding-bottom:20px;">
            <el-dropdown trigger="click" style="float:right;">
                <i class="fa fa-ellipsis-h" aria-hidden="true" style="font-size:20px"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="cancelJobMatch"><i class="el-icon-circle-close"></i>Cancel Job Match</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div style="float:right;">
          <span>Status: 
              <span style="word-break: break-word;" v-if="jobSeekerInfo.employerStatus === 1"> Reached Out</span>
              <span style="word-break: break-word;" v-if="jobSeekerInfo.employerStatus === 2"> Connected</span>
              <span style="word-break: break-word;" v-if="jobSeekerInfo.employerStatus === 3"> Interview Process</span>
          </span>
        </div>
      </div>      
    </div>

    <div class="ts-modal--sga-header">
      <div class="ts-modal--sga-header_profile">
        <div>
          <span class="header">Role Details</span>
        </div>
      </div>
    </div>

    <div class="ts-modal--tabs">
      <el-tabs v-model="activeTab" type="card">

        <el-tab-pane name="upskilling" v-if="jobSeekerInfo.fullSGA.sgaUpSkills">
					<span slot="label"><i class="el-icon-star-on"></i> Upskilling</span>
          <span class="h6">Upskilling Required</span>
					<div class="sga-split">
						<div class="sga-items" v-if="jobSeekerInfo.fullSGA.sgaUpSkills.knowledgeRegularlyUsed">
							<div class="sga-items_item heading"><span>Knowledge</span></div>
							<div class="sga-items_item flexed" v-for="(upskill, index) in jobSeekerInfo.fullSGA.sgaUpSkills.knowledgeRegularlyUsed" :key="index" style="word-break: break-word;">
								<img src="~../../../assets/img/upskill3.svg">
								<div class="right">
									<span>{{ upskill.selection }}</span>
								</div>
							</div>
						</div>
						<div class="sga-items" v-if="jobSeekerInfo.fullSGA.sgaUpSkills.workingPracticeSkills">
							<div class="sga-items_item heading"><span>Skills</span></div>
							<div class="sga-items_item flexed" v-for="(upskill, index) in jobSeekerInfo.fullSGA.sgaUpSkills.workingPracticeSkills" :key="index" style="word-break: break-word;">
								<img src="~../../../assets/img/upskill3.svg">
								<div class="right">
									<span>{{ upskill.selection }}</span>
								</div>
							</div>
						</div>
					</div>
        </el-tab-pane>

        <el-tab-pane label="Tasks" name="tasks">
          <span class="h6">Tasks</span>
					<div class="sga-items">
						<div class="sga-items_item flexed" v-for="(task, index) in jobSeekerInfo.fullSGA.sgaYourJob.jobDescriptionTasks" :key="index" style="word-break: break-word;">
							<div v-if="task.indexOf('`') > -1">
                <div v-if="code !== 'Others'">
                  <span> {{ task.split("`")[0] }} </span>
                </div>
              </div>
              <div v-if="code == 'Others'">
                <div v-if="task.indexOf('`') == -1">
                  <span class="class_Others">{{ task }}</span>
                </div>
              </div>
						</div>
					</div>
        </el-tab-pane>

        <el-tab-pane label="Activities" name="activities">
          <span class="h6">Activities</span>
					<div class="sga-items">
						<div class="sga-items_item flexed" v-for="(activity, index) in jobSeekerInfo.fullSGA.sgaHiddenExtras.workingPracticeActivities" :key="index">
							<span>{{ activity.selection }}</span>
						</div>
					</div>
        </el-tab-pane>

        <el-tab-pane label="Education" name="education">
          <span class="h6">Education</span>
          <div v-if="this.jobSeekerInfo.fullSGA.sgaEducation" class="sga-split" style="height: 400px !important; overflow-y: scroll">
            <div class="sga-items no_border">
              <div class="sga-items_item heading">
                <strong>Second Level Education</strong>
              </div>
              <div class="with_border" v-if="this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.highSchoolDiploma">
                <span>High School Diploma</span>
                <div class="sga-items_item no_border">
                  <span>High School Diploma</span>
                  <span v-if="this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.highSchoolDiplomaAttending">
                    Graduation Date : {{this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.highSchoolDiplomaGraduationDate | moment("MMMM DD, YYYY")}}
                  </span>
                </div>
              </div>
              <div class="with_border" v-if="this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.ged">
                <span>GED</span>
                <div class="sga-items_item no_border">
                  <span>GED</span>
                  <span v-if="this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.gedAttending">
                    Graduation Date : {{this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.gedGraduationDate | moment("MMMM DD, YYYY")}}
                  </span>
                </div>
              </div>
              <div class="with_border" v-if="this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.aLevels">
                <span>A Levels</span>
                <div class="sga-items_item no_border" v-for="(a_level, index) in this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.aLevelDetails" :key="index">
                  <span>{{ a_level.grade }} - {{ a_level.subject }}</span>
                </div>
              </div>
              <div class="with_border" v-if="this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.leavingCert">
                <span>Leaving Cert</span>
                <div class="sga-items_item no_border">
                  <span>Leaving Cert</span>
                </div>
              </div>
              <div class="with_border" v-if="this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.oLevels">
                <span>O Levels</span>
                <div class="sga-items_item no_border" v-for="(o_level, index) in this.jobSeekerInfo.fullSGA.sgaEducation.secondLevelEducation.oLevelDetails" :key="index">
                  <span>{{ o_level.grade }} - {{ o_level.subject }}</span>
                </div>
              </div>
              <div class="sga-items_item heading">
                <strong>Fourth Level Education</strong>
              </div>
              <div class="with_border" v-if="this.jobSeekerInfo.fullSGA.sgaEducation.fourthLevelEducation.mastersDegree">
                <span>Masters Degree</span>
                <div class="sga-items_item no_border" v-for="(ma_degree, index) in this.jobSeekerInfo.fullSGA.sgaEducation.fourthLevelEducation.mastersDegreeDetails" :key="index">
                  <span>{{ ma_degree.courseTitle }}</span>
                  <span style="word-break: break-word" v-if="ma_degree.currentlyAttending">
                    - Graduation Date : {{ ma_degree.graduationDate | moment("MMMM DD, YYYY") }}
                  </span>
                </div>
              </div>
              <div class="with_border" v-if="this.jobSeekerInfo.fullSGA.sgaEducation.fourthLevelEducation.doctoralDegree">
                <span>Masters Degree</span>
                <div class="sga-items_item no_border" v-for="(phd_degree, index) in this.jobSeekerInfo.fullSGA.sgaEducation.fourthLevelEducation.doctoralDegreeDetails" :key="index">
                  <span>{{ phd_degree.courseTitle }}</span>
                  <span style="word-break: break-word" v-if="phd_degree.currentlyAttending">
                    - Graduation Date :{{ phd_degree.graduationDate | moment("MMMM DD, YYYY") }}
                  </span>
                </div>
              </div>
            </div>
            <div class="sga-items">
              <div class="sga-items_item heading">
                <strong>Third Level Education</strong>
              </div>
              <div class="with_border" v-if="this.jobSeekerInfo.fullSGA.sgaEducation.thirdLevelEducation.associateDegree">
                <span>Associate Degree</span>
                <div class="sga-items_item no_border" v-for="(assoc_degree, index) in this.jobSeekerInfo.fullSGA.sgaEducation.thirdLevelEducation.associateDegreeDetails" :key="index">
                  <span>{{ assoc_degree.courseTitle }}</span>
                  <span style="word-break: break-word" v-if="assoc_degree.currentlyAttending">
                    - Graduation Date :{{assoc_degree.graduationDate | moment("MMMM DD, YYYY")}}
                  </span>
                </div>
              </div>
              <div class="with_border" v-if="this.jobSeekerInfo.fullSGA.sgaEducation.thirdLevelEducation.bachelorsDegree">
                <span>Bachelors Degree</span>
                <div class="sga-items_item no_border" v-for="(bs_degree, index) in this.jobSeekerInfo.fullSGA.sgaEducation.thirdLevelEducation.bachelorsDegreeDetails" :key="index">
                  <span>{{ bs_degree.courseTitle }}</span>
                  <span style="word-break: break-word" v-if="bs_degree.currentlyAttending">
                    - Graduation Date :{{ bs_degree.graduationDate | moment("MMMM DD, YYYY") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label = "Certifications" name="certifications">
          <span class="h6">Certifications</span>
            <div class="sga-items">
              <div class="sga-items_item" v-for="(cert, index) in jobSeekerInfo.fullSGA.sgaCertifications.userCertifications" :key="index">
                <div v-if="jobSeekerInfo.fullSGA.sgaCertifications.userCertifications.length == 1 && cert.codeDetailDesc == null">
                  <span>N/A</span>
                </div>
                <div v-else>
                  <span><i class="fas fa-shield-alt" style="color: #00c875; margin-right: 1em" v-if="cert.verified === true"></i>
                  {{ cert.codeDetailDesc }}
                  </span>
                </div>
              </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Knowledge" name="knowledge">
          <span class="h6">Knowledge</span>
          <br/><br/>
          <div>
            <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" style="padding:10px">
              <span class="sga-items_item heading" style="font-weight: 550!important; font-size: 15px">Expected by employer</span>
              <el-row>
                <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                  <div class="sga-items_item" v-for="(knowledge, index) in jobSeekerInfo.fullSGA.sgaKnowledge.knowledgeRegularlyUsed" v-if="knowledge.value == 'IN'" :key="index">
                    <span>{{ knowledge.selection }}</span>
                    <span>{{ knowledge.yearsOfExperience }} years experience</span>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" style="padding:10px">
              <span class="sga-items_item heading" style="font-weight: 550!important; font-size: 15px">Employee adds to role</span>
              <el-row>
                <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <div class="sga-items_item" v-for="(knowledge, index) in jobSeekerInfo.fullSGA.sgaKnowledge.knowledgeRegularlyUsed" v-if="knowledge.value == 'OUT'" :key="index">
                      <span>{{ knowledge.selection }}</span>
                      <span>{{ knowledge.yearsOfExperience }} years experience</span>
                    </div>
                </el-col>
              </el-row>
            </el-col>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Skills" name="skills">
          <span class="h6">Skills</span>
					<br/><br/>
          <div>
            <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" style="padding:10px">
              <span class="sga-items_item heading" style="font-weight: 550!important; font-size: 15px">Expected by employer</span>
              <el-row>
                <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                  <div class="sga-items_item" v-for="(skill, index) in jobSeekerInfo.fullSGA.sgaSkills.workingPracticeSkills" v-if="skill.value == 'IN'" :key="index">
                    <span>{{ skill.selection }}</span>
                    <span>{{ skill.yearsOfExperience }} years experience</span>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" style="padding:10px">
              <span class="sga-items_item heading" style="font-weight: 550!important; font-size: 15px">Employee adds to role</span>
              <el-row>
                <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <div class="sga-items_item" v-for="(skill, index) in jobSeekerInfo.fullSGA.sgaSkills.workingPracticeSkills" v-if="skill.value == 'OUT'" :key="index">
                      <span>{{ skill.selection }}</span>
                      <span>{{ skill.yearsOfExperience }} years experience</span>
                    </div>
                </el-col>
              </el-row>
            </el-col>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Essential Skills" name="mindsets">
         <span class="h6">Essential Skills</span>
         <br/><br/>
          <div>
            <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" style="padding:10px">
              <span class="sga-items_item heading" style="font-weight: 550!important; font-size: 15px">Expected by employer</span>
              <el-row>
                <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                  <div class="sga-items_item" v-for="(mindset, index) in jobSeekerInfo.fullSGA.sgaMindset.mindsets" v-if="mindset.value == 'IN'" :key="index">
                    <span>{{ mindset.selection }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" style="padding:10px">
              <span class="sga-items_item heading" style="font-weight: 550!important; font-size: 15px">Employee adds to role</span>
              <el-row>
                <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <div class="sga-items_item" v-for="(mindset, index) in jobSeekerInfo.fullSGA.sgaMindset.mindsets" v-if="mindset.value == 'OUT'" :key="index">
                      <span>{{ mindset.selection }}</span>
                    </div>
                </el-col>
              </el-row>
            </el-col>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>    

    <span slot="footer" class="ts-modal--footer">
      <el-button type="primary" @click="closeModal()">Close</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {  
    created(){
        this.jobSeekerInfo = this.$route.params.data;
    },    
    data() {
        return {
            jobSeekerInfo: {},
            showModal: true,
            activeTab: 'tasks'
        };
    },
    watch: {
      showModal(v) {
        if (v === false);
            this.$emit('close-modal');
        }
    },
    computed: {
      currentUser() {
          return this.$store.state.account.current_user;
      }
    },
    methods: {
      closeModal() {
            this.showModal = false;
            this.$router.push({ name: 'jobseeker-statusboard', params: { activeTab: "second" }});
        },
      cancelJobMatch() {
          this.showModal = false;
          this.jobSeekerInfo.isFrom = "JobSeekerInfoDialog";
          this.$router.push({ name: 'DeclineJobMatchDialog', params: { data: this.jobSeekerInfo}});
      }   
    }
};
</script>

<style scoped>
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
.el-icon-arrow-down {
    font-size: 12px;
  }
.demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
  }  
</style>